import { TParadiseLLMPromptsQueryParams } from "src/data/paradise/paradiseLLMPrompts/types/paradiseLLMPromptsQueryTypes"
import {
  TSetSearchParamsProp,
  TSortedSearchParams,
  useSearchParams,
} from "src/router/useSearchParams"
import { Nullable } from "src/utils/tsUtil"

type TParadiseLLMSearchFilterConfig = {
  [K in keyof Required<
    Omit<TParadiseLLMPromptsQueryParams, "limit" | "sort_by" | "sort_order">
  > as `llm_prompts_${K}`]: NonNullable<TParadiseLLMPromptsQueryParams[K]>
}

export type TParadiseLLMFilters = Nullable<TParadiseLLMSearchFilterConfig>
export type TSortedParadiseLLMFilters =
  TSortedSearchParams<TParadiseLLMSearchFilterConfig>

export function useParadiseLLMPromptsFilter(): {
  filter: TParadiseLLMFilters
  sortedFilters: TSortedParadiseLLMFilters
  setFilter: TSetSearchParamsProp<TParadiseLLMFilters>
  setOffset: (offset: number) => void
  offset: number
} {
  const {
    searchParams: filter,
    setSearchParams: setFilter,
    setSearchParamsAll,
    sortedSearchParams: sortedFilters,
  } = useSearchParams({
    keys: [
      {
        key: "llm_prompts_offset",
        type: "number",
      },
      {
        key: "llm_prompts_category",
        type: "string",
        allowedValues: [
          "guest_message_input_sanitization",
          "guest_message_response",
          "guest_message_output_sanitization",
        ],
      },
      {
        key: "llm_prompts_created_by_user_id",
        type: "string",
      },
    ],
  })

  return {
    filter: filter,
    // We do not count pagination as a filter
    sortedFilters: sortedFilters.filter((f) => f.key !== "llm_prompts_offset"),
    setFilter: (key, value) => {
      if (key === "llm_prompts_offset") {
        return
      }

      // Make sure we reset paging on filter
      setSearchParamsAll({
        [key]: value,
        llm_prompts_offset: 0,
      })
    },
    setOffset: (offset: number) => {
      setFilter("llm_prompts_offset", offset)
    },
    offset: filter.llm_prompts_offset || 0,
  }
}
